export default {
    formData: (state) => state.formData,
    gymMembershipData: (state) => state.gymMembershipData,
    formSummary: (state) => state.formSummary,
    formConditionals: (state) => state.formConditionals,
    isLoading: (state) => state.isLoading
}